import React from "react";
import "./paintEnhancement.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function PaintEnhancement() {
  return (
    <>
    <Helmet>
      <title>Best Paint Enhancement Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Restore your car's original shine with professional paint enhancement service at AutoCare in Palwal. We offer premium car repair & detailing solutions for a flawless, showroom-like finish."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/paint-enhancement"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Paint Enhancement Service in Palwal</h1>

          <p>
            Restore your car’s original shine with
            <strong> professional paint enhancement service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            offering premium <strong>car repair & detailing solutions</strong>
            for a flawless, showroom-like finish.
          </p>

          <h2>What is Paint Enhancement?</h2>
          <p>
            Paint enhancement is an advanced detailing process that removes
            swirl marks, light scratches, oxidation, and dullness from your
            car’s paint, significantly improving gloss and clarity without
            repainting.
          </p>

          <h2>Benefits of Paint Enhancement</h2>
          <ul>
            <li>Restores deep gloss and paint clarity</li>
            <li>Removes swirl marks & light scratches</li>
            <li>Improves overall vehicle appearance</li>
            <li>Prepares paint for ceramic coating or waxing</li>
            <li>Increases resale value of your car</li>
          </ul>

          <h2>Why AutoCare is the Best Choice?</h2>
          <ul>
            <li>One of the <span className="highlight">best paint enhancement services in Palwal</span></li>
            <li>Professional tools & premium compounds</li>
            <li>Skilled detailing experts</li>
            <li>Affordable & transparent pricing</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Paint Enhancement Near You</h2>
          <p>
            Searching for the <span className="highlight">best paint enhancement near me</span>?
            Choose <strong>AutoCare</strong> for expert detailing, long-lasting results,
            and unmatched car care quality.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Paint Enhancement Service
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/paintEnhancement.webp"
            alt="Best Paint Enhancement Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
